/*
    🔥 UTILIDADES DE ESCALA

    ⚠️ POR QUÉ SVG A MANO Y NO UNA LIBRERÍA

    Recharts, Chart.js y compañía pesan entre 200 y 500 KB y pintan con
    colores que se pasan por JS. En esta template el color vive en CSS
    y cambia con data-theme y con los once niveles de estética: una
    librería obligaría a leer las variables desde JavaScript en cada
    render y a re-pintar el gráfico entero al cambiar de tema.

    Estos cuatro gráficos son SVG plano. El color sale de CSS como
    todo lo demás, el tema cambia solo, y no suman una dependencia a un
    template pensado para arrancar proyectos.

    Si algún día necesitás zoom, brush o veinte tipos de gráfico,
    ahí sí metés la librería: esto cubre el 90% de un dashboard.
*/

// 🔥 Techo "redondo" para que el eje no diga 4.837
export const onNiceMax = (value) => {

    if (!value || value <= 0) return 10;

    const MAGNITUDE = 10 ** Math.floor(Math.log10(value));

    const NORMALIZED = value / MAGNITUDE;

    const STEP = NORMALIZED <= 1 ? 1
        : NORMALIZED <= 2 ? 2
            : NORMALIZED <= 5 ? 5
                : 10;

    return STEP * MAGNITUDE;
};

export const onBuildTicks = (max, count = 4) => (
    Array.from({ length: count + 1 }, (_, i) => (max / count) * i)
);

/*
    🔥 Formato corto para los ejes

    1.284.900 en un eje ocupa media pantalla. 1,3 M se lee igual de bien
    y deja lugar a las barras, que es lo que importa.
*/
export const onFormatShort = (value) => {

    const ABS = Math.abs(value);

    if (ABS >= 1_000_000) return `${(value / 1_000_000).toFixed(ABS >= 10_000_000 ? 0 : 1)}M`;

    if (ABS >= 1_000) return `${(value / 1_000).toFixed(ABS >= 10_000 ? 0 : 1)}k`;

    return String(Math.round(value * 100) / 100);
};

/*
    🔥 Convierte una serie de valores en puntos del viewBox

    ⚠️ Con UN SOLO punto no se puede dividir por (length - 1): daría
       infinito. Ese punto se centra.
*/
export const onBuildPoints = (values, { width, height, max, padTop = 0 }) => {

    const USABLE = height - padTop;

    if (values.length === 1) {
        return [{ x: width / 2, y: padTop + USABLE - (values[0] / max) * USABLE }];
    }

    return values.map((value, index) => ({
        x: (index / (values.length - 1)) * width,
        y: padTop + USABLE - (Math.max(0, value) / max) * USABLE,
    }));
};

// 🔥 Serie vacía o toda en cero: devolvemos un piso para no dividir por 0
export const onResolveMax = (values, explicitMax = null) => {
    if (explicitMax) return explicitMax;
    return onNiceMax(Math.max(0, ...values));
};
